export default {
    //查询角色类型接口
    queryRoleTypeInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/roleType/queryRoleTypeInfo', params, response);
    },
    //角色类型添加接口
    addRoleTypeInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/roleType/addRoleTypeInfo', params, response);
    },
    //角色类型编辑接口
    modifyRoleTypeInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/roleType/modifyRoleTypeInfo', params, response);
    },
    //角色类型删除接口
    delRoleTypeInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/roleType/delRoleTypeInfo', params, response);
    }
};
